import React from 'react';

const translations = {
  de: {
    title: 'Werde Teil der Community',
    desc: 'Teile Feedback, stelle Fragen oder vernetze dich mit anderen Vereinen – gemeinsam machen wir das System noch besser!',
    join: 'Community beitreten',
    heading: 'Kostenlos. Für immer.',
    freeForever: 'For the ❤️ of the game.',
    sharePhotos: 'Dieses Scoreboard ist und bleibt in der Grundversion kostenlos – aus Liebe zum Sport. Wenn du etwas zurückgeben möchtest: Investiere in neue Ausrüstung für deine Junioren und zeige uns dein Scoreboard in Aktion auf Instagram!',
    shareOnInstagram: 'Zeig uns dein Scoreboard',
  },
  en: {
    title: 'Join the Community',
    desc: 'Share feedback, ask questions, or connect with other clubs – together we make the system even better!',
    join: 'Join community',
    heading: 'Free. Forever.',
    freeForever: 'For the ❤️ of the game.',
    sharePhotos: 'This scoreboard is and will remain free in the basic version – for the love of the sport. If you want to give back: Invest in new equipment for your youth and show us your scoreboard in action on Instagram!',
    shareOnInstagram: 'Show us your scoreboard',
  }
};

export default function CommunitySection({ lang = 'de' }) {
  const t = translations[lang];
  return (
    <div className="flex flex-col justify-top py-28 w-full max-md:py-24">
      <div className="flex flex-wrap gap-10 justify-top items-start max-w-[1280px] mx-auto px-8">
        <div className="flex flex-col flex-1 min-w-[240px] max-w-[640px]">
          
          <h2 className="mt-4 text-6xl font-extrabold leading-[67px] text-stone-900 max-md:text-4xl max-md:leading-[54px]">
            {t.freeForever}
          </h2>
        </div>
        <div className="flex flex-col flex-1 min-w-[240px] max-w-[640px] justify-end">
          <p className="text-lg leading-7 text-stone-900">{t.sharePhotos}</p>
          <div className="flex flex-wrap gap-4 mt-6">
            <a
              href="https://instagram.com/rinkhockeyscoreboard/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-6 py-3 bg-red-500 hover:bg-red-600 transition-colors text-white rounded-lg text-sm min-h-[53px] min-w-[140px]"
              aria-label="Share your scoreboard photos on Instagram (opens in new tab)"
            >
              {t.shareOnInstagram}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}